import React from 'react';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { DropzoneDialog } from 'mui-file-dropzone';

import { useEquipmentAssets } from '../../api';

export const UploadImagesForExistingEquipmentDialog = () => {
  const { isOpen, handleClose, data } = useModal(ModalsKeys.UploadImagesForExistingEquipmentDialog);

  if (!data.equipmentId) throw new Error('Equipment id is required');

  const { handleUploadImages } = useEquipmentAssets();

  const onSave = async (files: File[]) => {
    await handleUploadImages(data.equipmentId, 'IMAGE', files);
    handleClose();
  };

  return (
    <DropzoneDialog
      fullWidth
      maxWidth="lg"
      open={isOpen}
      filesLimit={5}
      onSave={onSave}
      fileObjects={[]}
      onClose={handleClose}
      maxFileSize={25000000}
      cancelButtonText="Cancel"
      submitButtonText="Submit"
      dialogTitle="Upload Equipment Images"
      acceptedFiles={['image/jpeg', 'image/png']}
    />
  );
};
